var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.series)?_c('apexchart',{attrs:{"type":"bar","height":325,"series":_vm.series,"options":_vm.options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }